<template>
     <div id='SideMenu' class='d-none d-md-block col-1'
         @mouseover='openMenu'
         @mouseleave='closeMenu'
         >
         <nav class='main-nav'>
             <Sidebar
                :menuList = menuList
                :class="{MenuOpenedClass: isNavOpen, MenuClosedClass: !isNavOpen}"
                :navOpen='isNavOpen'
            />
         </nav>
     </div>
</template>

<script>
    import Sidebar from './Sidebar.vue';

    export default {
        name: 'SideMenu',
        components: {
            Sidebar
        },
        data(){
            return{
                isNavOpen: false,
                menuList: [
                    {
                      path: '/power-scan',
                      title: 'PowerScan',
                      icon: 'PowerScan'
                    },
                ]
            }
        },
        methods:{
            openMenu(){
                this.isNavOpen = true;
            },
            closeMenu(){
                this.isNavOpen = false;
            }
        }
    }
</script>
